import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TwoLanes } from "@/components/site/TwoLanes";
import { PhonesForSale } from "@/components/site/PhonesForSale";
import { RepairServices } from "@/components/site/RepairServices";
import { RepairDialog } from "@/components/site/RepairDialog";
import { WhyUs } from "@/components/site/WhyUs";
import { FindUs } from "@/components/site/FindUs";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";

export default function Home() {
  const [repair, setRepair] = useState({ open: false, service: "" });
  const openRepair = (service) => setRepair({ open: true, service: typeof service === "string" ? service : "" });

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero onBookRepair={openRepair} />
        <TwoLanes onBookRepair={openRepair} />
        <PhonesForSale />
        <RepairServices onBookRepair={openRepair} />
        <WhyUs />
        <FindUs />
      </main>
      <Footer />
      <MobileBar />
      <RepairDialog open={repair.open} initialService={repair.service} onOpenChange={(o) => setRepair((r) => ({ ...r, open: o }))} />
    </div>
  );
}
